import {
  Stack,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  Avatar, Typography,
  Paper,
  Card,
  Divider,
  CardActions,
  Button,
  Skeleton,
} from "@mui/material";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import InfoIcon from "../../shared/icon/info-icon";
import LocationIcon from "../../shared/icon/location-icon";
import DevicesIcon from "../../shared/icon/devices-icon";
import AccountIcon from "../../shared/icon/account-icon";
import AppsIcon from "../../shared/icon/apps-icon";
import CurrencyIcon from "../../shared/icon/currency-icon";
import { RootStateType } from "../../redux/features/rootSlice";
import { useArcAuth } from "@arcauth/react-sdk";
import { getInitials } from "../../shared/util/encrypt.decrypt";
import LockIcon from "../../shared/icon/lock-icon";


const Dashboard = () => {
  const { isAuthenticated, login } = useArcAuth();
  const {userLoading} = useSelector(
    (state: RootStateType) => state.userStateReducer
  );
  let user = useSelector(
    (state: RootStateType) => state.userStateReducer.user
  );
  const navigate = useNavigate();
  const headerText = getInitials(user?.firstname);
  const configData = useSelector((state: RootStateType) => state.configStateReducer.clientConfig);
  //console.log("configData in dashboard ", configData);
  const handleAccountNavigation = () => {
    navigate('/account');
  };
  const handleAddressNavigation = () => {
    navigate('/address');
  };
  const handleSecurityNavigation = () => {
    navigate('/security');
  };

  useEffect(() => {
    // We are not logged in, redirect
    if (!isAuthenticated) {
      login();
    }
  }, [isAuthenticated, navigate])

// console.log("user?.imageurl ",user?.imageurl, "  ", headerText)
  return (

    <Box>
      {userLoading ? <>
        <Stack gap={1} alignItems={'center'}>
          <Skeleton
            variant="circular"
            width={100}
            height={100}

          />
          <Skeleton
            variant="rectangular"
            width={200}
            height={50}
          />
          <Skeleton
            variant="rectangular"
            width={400}
            height={20}
          />
        </Stack>
        <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: '1fr 1fr 1fr', py: 3, '.MuiPaper-root ': { display: 'flex', flexDirection: 'column', minHeight: 180 }, '.MuiTypography-root': { display: 'flex', alignItems: 'center', gap: '.7rem' }, '.MuiCardActions-root': { borderTop: '1px solid #eee', p: 0, mt: 'auto' } }}>
          <Skeleton
            variant="rectangular"
            width={300}
            height={150}
          />
          <Skeleton
            variant="rectangular"
            width={300}
            height={150}
          />
          <Skeleton
            variant="rectangular"
            width={300}
            height={150}
          />
          {/* <Skeleton
            variant="rectangular"
            width={300}
            height={150}
          />
          <Skeleton
            variant="rectangular"
            width={300}
            height={150}
          />
          <Skeleton
            variant="rectangular"
            width={300}
            height={150}
          /> */}
        </Box>


      </> : <>

        <Stack textAlign={'center'} gap={1} alignItems={'center'}>
          <Avatar sx={{backgroundColor:"#6D6D88", width:{xs: '66px', md: '96px'}, height:{xs: '66px', md: '96px'}, fontSize: {xs: '1.8rem', md: '3rem'} }}>
            {user?.imageurl ?
              (<img crossOrigin="anonymous" src={`${user?.imageurl}`} alt="" width={96} height={96} style={{width: '100%', height: '100%', objectFit: 'cover', display: 'block'}} />)
              : (headerText)}
          </Avatar>
          <Typography variant="h1" color="initial" fontSize={{xs: '1.5rem', md: '2.5rem'}}>
            Welcome, {user?.firstname}
          </Typography>
          <Typography variant="body2" color="initial">
            Manage your info, privacy, and security to make Arc work better for you
          </Typography>
        </Stack>
        <Stack direction={{sm: 'row'}} sx={{alignItems: "center", justifyContent: 'center', gap: 2, gridTemplateColumns: '1fr 1fr 1fr', py: 3, '.MuiPaper-root ': { display: 'flex', flexDirection: 'column', minHeight: 180 }, '.MuiTypography-root': { display: 'flex', alignItems: 'center', gap: '.7rem' }, '.MuiCardActions-root': { borderTop: '1px solid #eee', p: 0, mt: 'auto', 'a': {pl: 0, ml: 0}, 'a:hover' : {backgroundColor: "transparent"} } }}>
          <Card elevation={0} sx={{ p: 2, width: {xs: '300px', sm: '270px', md: '300px'}}}>
            <Stack gap={1} pb={1}>
              <Typography variant="h2" sx={{ fontSize: "1.2rem", fontWeight: 400 }}><InfoIcon /> Personal information</Typography>
              {/* <Typography variant="body2" color="initial">Arc account : ARC23125454</Typography> */}
              <Typography variant="body2" color="initial">{user?.email}</Typography>
              <Typography variant="body2" color="initial">{user?.phone}</Typography>
            </Stack>
            <CardActions>
            <Button aria-label="Manage account" variant="text" size="small"   sx={{ color: "primary.dark", fontSize: "0.875rem" }} onClick={handleAccountNavigation}>Manage account</Button>
            </CardActions>
          </Card>
            {configData.appType === 'E-commerce' ?
              <>
                <Card elevation={0} sx={{ p: 2, width: 300 }}>
                  <Stack gap={1} pb={1}>
                    <Typography variant="h5" color="initial" fontWeight="normal">
                      <LocationIcon /> My addresses
                    </Typography>

                    {user?.address && user?.address.filter((item: any) => item.isdefault).length === 0 && (
                      <Typography variant="body2" color="initial" fontWeight="normal">
                        Add your address for accurate location-based services
                      </Typography>
                    )}

                    {user?.address && user?.address.filter((item: any) => item.isdefault)
                      .map((defaultAddress: any) => (
                        <Typography key={defaultAddress.id} variant="body2" color="initial">
                          {`${defaultAddress?.name ?? ""}\n${defaultAddress?.street1 ?? ""}\n${defaultAddress?.street2 ?? ""}\n${defaultAddress?.addressname ?? ""}\n${defaultAddress?.city ?? ""}, ${defaultAddress?.zip ?? ""}`}
                        </Typography>
                      ))
                    }
                  </Stack>
                  <CardActions>
                    <Divider sx={{ my: 1 }} />
                    <Button variant="text" size="small" onClick={handleAddressNavigation}>
                      Manage addresses
                    </Button>
                  </CardActions>
                </Card>
              </>
              :
              null
            }

          <Card elevation={0} sx={{ p: 2, width: 300 }}>
            <Stack gap={1} pb={1}>
              <Typography variant="h2" sx={{ fontSize: "1.2rem", fontWeight: 400 }}><LockIcon /> Security </Typography>
              <Typography variant="body2" color="initial">Manage your account preferences and details in one convenient location</Typography>
            </Stack>
            <CardActions>
              <Divider sx={{ my: 1 }} />
              <Button aria-label="View details" variant="text" size="small"   sx={{ color: "primary.dark", fontSize: "0.875rem" }} onClick={handleSecurityNavigation}>See details</Button>
            </CardActions>
          </Card>
        {/*   <Card elevation={0} sx={{ p: 2 }}>
            <Stack gap={1} pb={1}>
              <Typography variant="h5" color="initial" fontWeight={'normal'}><AccountIcon />  My account</Typography>
              <Typography variant="body2" color="initial">Efficiently manage your arc accounts with accuracy and compliance.</Typography>
            </Stack>
            <CardActions>
              <Divider sx={{ my: 1 }} />
              <Button variant="text" size="small" href="/account">Manage account</Button>
            </CardActions>
          </Card>
          <Card elevation={0} sx={{ p: 2 }}>
            <Stack gap={1} pb={1}>
              <Typography variant="h5" color="initial" fontWeight={'normal'}><AppsIcon />  My Apps</Typography>
              <Typography variant="body2" color="initial">Efficiently manage your arc accounts with accuracy and compliance.</Typography>
            </Stack>
            <CardActions>
              <Divider sx={{ my: 1 }} />
              <Button variant="text" size="small" href="/apps">Manage apps</Button>
            </CardActions>
          </Card>
          <Card elevation={0} sx={{ p: 2 }}>
            <Stack gap={1} pb={1}>
              <Typography variant="h5" color="initial" fontWeight={'normal'}><CurrencyIcon />  My Subscription</Typography>
              <Typography variant="body2" color="initial">Manage your subscriptions easily with tailored settings.</Typography>
            </Stack>
            <CardActions>
              <Divider sx={{ my: 1 }} />
              <Button variant="text" size="small" href="/subscription">Manage subscription</Button>
            </CardActions>
          </Card> */}
        </Stack>
      </>}


    </Box>
  );
};

export default Dashboard;
